$(document).ready(function($){
  if(jQuery(".sp-breadcrumb a:nth-child(3)").text().includes('Sarees')){
    jQuery('.extra-link').hide().css('opacity','0');
  if(jQuery(".sp-breadcrumb a:nth-child(3)").text().includes('Sarees')){
    jQuery('.extra-link').hide().css('opacity','0');
  }
}

 // $('aside ._1ip0g651._1fragemfi._1frageme0._1fragemg3._1fragemgk').append("Please Note: You'll have to pay International Shipping Charges to our Shipping Partner. Additionally you can check our Shipping Policy for further clarity."); 
jQuery('.quote_content p').append("<img class='vikas-sty' src='https://cdn.shopify.com/s/files/1/0649/2553/2382/files/testimonial.png?v=1654178107'>");
jQuery(".col-lg-4.col-12.tc.col-md-12.tr_lg.dn_true_1024").prepend("<a href='https://api.whatsapp.com/send?phone=7045534773' target='_blank' style='color:#fff;'><img src='https://cdn.shopify.com/s/files/1/0649/2553/2382/files/Whatsapp0.png?v=1654348778'>&nbsp;&nbsp;+91-70455 34773</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;");  
jQuery(".col-lg-4.col-12.tc.col-md-12.tr_lg.dn_true_1024").prepend("<a href='/pages/video-shopping-appointment' target='_blank' style='color:#fff;'><img src='https://cdn.shopify.com/s/files/1/0649/2553/2382/files/Video_shopping0.png?v=1654348779'>&nbsp;&nbsp;Video Shopping &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>");
jQuery(".cat_grid_item__count").text("View Collection");  
jQuery(".extra-link").prepend("  <i class='fa fa-bar-chart'></i> ");
// jQuery('.variations').append('<div class="main_layout"><div class="layout"><div><div class="layout-tofit"><img src="https://cdn.shopify.com/s/files/1/0649/2553/2382/files/measurement.svg?v=1684915426" class="psl-icon"><span class="bold">To Fit:</span></div></div><div><div class="layout-size"><div class="layout"><p class="bust">Bust - 32in</p><div class="black">|</div></div><div class="layout"><p class="waist">Waist -26in</p><div class="black">|</div></div><div class="layout"><p class="hip">Hip - 36in</p></div></div></div></div></div><div class="shipping"><img src="https://cdn.shopify.com/s/files/1/0649/2553/2382/files/standard-shipping.svg?v=1684994341" alt="shipping"><p><strong>Standard Shipping: </strong>The estimated shipping date for this product is by <span class="shippingdate"> </span>. Please note that this is the shipping date and not the delivery date.</p></div>');
if (
    !$(".product-categories").text().toLowerCase().includes("saree")
) {
    jQuery('.variations').append('<div class="main_layout"><div class="layout"><div><div class="layout-tofit"><img src="https://cdn.shopify.com/s/files/1/0649/2553/2382/files/measurement.svg?v=1684915426" class="psl-icon"><span class="bold">To Fit:</span></div></div>...');
}
jQuery('.variations_button').prepend('<div class="shipping2" style="display:none;"><img src="https://cdn.shopify.com/s/files/1/0649/2553/2382/files/standard-shipping.svg?v=1684994341" alt="shipping"><p><strong>Standard Shipping :</strong>The estimated shipping date for this product is by  <span class="shippingdate"> </span>. Please note that this is the shipping date and not the delivery date.</p></div>');
  if($('.product-categories').find('.current-cat').children('a').html()=='Vegan Bridal Lehengas' || $('.product-categories').find('.current-cat').children('a').html()=='Vegan Lehangas') 
{
  $(".shipping2").show();
 var date1 =new Date();
 if($('#Unstiched_lehenga:contains("UNSTITCHED")').length >0){  //for unstiched lehenga
 
    if($("#txt_vl_in_ppr").hasClass('dn')){
       date1.setDate(date1.getDate() + 40)
    var yyyy = date1.getFullYear().toString();
       var mm = (date1.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date1.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
    else
    {
         date1.setDate(date1.getDate() + 10)
    var yyyy = date1.getFullYear().toString();
       var mm = (date1.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date1.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
  $(".shippingdate").html(shippingdate)
}
else if($('#ready_made:contains("READY MADE")').length >0){   

  if($('.variations').length >0){
    $(".shipping2").hide();
  }
else{
    if($("#txt_vl_in_ppr").hasClass('dn')){
       date1.setDate(date1.getDate() + 40)
    var yyyy = date1.getFullYear().toString();
       var mm = (date1.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date1.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
    else
    {
         date1.setDate(date1.getDate() + 10)
    var yyyy = date1.getFullYear().toString();
       var mm = (date1.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date1.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
}
 
  $(".shippingdate").html(shippingdate)
}
}
jQuery('.nt-swatch').click(function(){   
    if ($(".product-categories").text().toLowerCase().includes("saree")) {
        return;
    }                                         
  var varianceattr = $(this).parents('div').attr('data-opname')
  if(varianceattr == 'size' || varianceattr == 'option'){
  var sizevalue = $(this).attr('data-value');
 $(".shipping2").hide();
switch(sizevalue){
  case"with-fall-edging":
  case"without-fall-edging":
    $('.main_layout').hide();
    $('.extra-link').hide();
    
    var dates = new Date();
    if($("#txt_vl_in_ppr").hasClass('dn')){
      dates.setDate(dates.getDate() + 40)
      var yyyy = dates.getFullYear().toString();
       var mm = (dates.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = dates.getDate().toString();
       var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
    else
    {
       dates.setDate(dates.getDate() + 7)
       var yyyy = dates.getFullYear().toString();
       var mm = (dates.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = dates.getDate().toString();
       var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
    }
   $(".shippingdate").html(shippingdate)
    break;
  default:
    
  var waist = parseInt(sizevalue) -6;
  var hip = parseInt(sizevalue) +4;
   $('.bust').text('Bust -' + sizevalue+ 'in');
   $('.waist').text('Waist -' + waist+ 'in');
   $('.hip').text('Hip -' + hip+ 'in');
  var date = new Date();
  if($(this).hasClass("nt_soldout")){
    date.setDate(date.getDate() + 40)

    var yyyy = date.getFullYear().toString();
       var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
  $(".shippingdate").html(shippingdate)

  }else{
      date.setDate(date.getDate() + 10)
    var yyyy = date.getFullYear().toString();
       var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
       var dd  = date.getDate().toString();
    var shippingdate = (dd[1]?dd:"0"+dd[0]) + "-" + (mm[1]?mm:"0"+mm[0]) + "-" +  yyyy
  $(".shippingdate").html(shippingdate)
  }
    break;
}
    
  }
  else{
   $('.is-size .swatch__list_pr .nt-swatch:first-child').click();
  }

});  
  
// when only one variation page on load  click
if($('.variations ul li').length == 1){
$('.nt-swatch').click();
}
  
// All products & variation Out of stock  

if($('.product-images .nt_label').hasClass('out-of-stock')){
    $('.swatch__list_pr .nt-swatch').addClass('nt_soldout');
}
  // for custom tailor
// Create Measurement Form Button
  var measurementFormButton = '<a class="measurement_form" target="blank" href="/pages/indowestern-custom-tailor-form">Custom Tailor</a>';

    // Append Measurement Form after Size Guide
    $(".extra-link a.cd.chp.ajax_pp_js").after(measurementFormButton);

// if ($('#ready_made').length) {
//             $('.measurement_form').attr('href', '/pages/lehengas-custom-tailor-form');
//    }
// if ($('#Unstiched_lehenga').length) {
//             $('.measurement_form').attr('href', '/pages/lehengas-custom-tailor-form');
//      }
// if ($('p#vegandress').length) {
//             $('.measurement_form').attr('href', '/pages/dresses-custom-tailor-form');
//      }

  // Code to be executed after 500 seconds
  //Step 1: Setting Up redirection using URL Params //
        //Ready Made
        // if ($('#ready_made').length) {
        //     $('.measurement_form').attr('href', "https://gcsveganfashion.com/pages/lehengas-custom-tailor-form/?formType=readyMade");
        // }
        // //Unstitched
        // if ($('#Unstiched_lehenga').length) {
        //     $('.measurement_form').attr('href', "https://gcsveganfashion.com/pages/lehengas-custom-tailor-form/?formType=unstitched");
        // }
        // if ($('p#vegandress').length) {
        //     $('.measurement_form').attr('href', '/pages/dresses-custom-tailor-form');
        // }
  var productTitle = jQuery("#shopify-section-pr_summary h1.product_title.entry-title").text();

//Ready Made
        if ($('#indo-western').length) {
            $('.measurement_form').attr('href', "/pages/indowestern-custom-tailor-form/?productName="+productTitle);
            console.log(productTitle);
        }
        if ($('#ready_made').length) {
            $('.measurement_form').attr('href', "https://gcsveganfashion.com/pages/lehengas-custom-tailor-form/?productName="+productTitle);
            console.log(productTitle);
        }
        // //Unstitched
        if ($('#Unstiched_lehenga').length) {
            var waist= jQuery(".waist").text();
            var hip= jQuery(".hip").text();
            $('.measurement_form').attr('href','https://gcsveganfashion.com/pages/lehengas-custom-tailor-form/?productName='+productTitle+'&'+waist+'&'+hip);
        }
        if ($('p#vegandress').length) {
            $('.measurement_form').attr('href', '/pages/dresses-custom-tailor-form/?productName='+productTitle);
            console.log(productTitle);
        }
        
   // var formType = window.location.search;

    // Variable containing the URL
var url = window.location.search;

// Decode the product name, handling potential spaces in the waist and hip parts
// var decodedProductName = decodeURIComponent(url.split("productName=")[1]);
// var decodedProductName1 = url.split("productName=")[1].replace(/%20/g, " ");
var rawProductName = url.includes("productName=") ? url.split("productName=")[1] : null;
var decodedProductName = rawProductName ? decodeURIComponent(rawProductName) : "";
var decodedProductName1 = rawProductName ? rawProductName.replace(/%20/g, " ") : "";
if((decodedProductName.includes('Waist')) && (decodedProductName.includes('Hip'))){
    jQuery("#unstitched").show();
    jQuery("#readymade").hide();
}
else{
    jQuery("#unstitched").hide();
    jQuery("#readymade").show();
}
var form_name = window.location.href;
if(form_name.includes('ecom-contact-form-ecom-8zu3hs17a2u')){
    jQuery('#unstitched').hide();
}
if(form_name.includes('ecom-contact-form-ecom-09a4pki4uu4s')){
    jQuery('#readymade').hide();
}
// Split the decoded name by "&" to separate product title, waist, and hip
var parts = decodedProductName.split("&");

// Extract the product title, waist, and hip values
var productTitle = parts[0];
var waist = parts[1];
var hip = parts[2];

// Set the product name, waist, and hip values
jQuery("#product_unstitched").val(productTitle);
jQuery("#product_name").val(decodedProductName1);
jQuery("#product_unstitched").css('pointer-events', 'none');
jQuery("#product_name").css('pointer-events', 'none');
jQuery("#waist_hip-info").val('To Fit: '+waist+' (Maximum) |'+hip+' (Maximum)')
jQuery("#waist_hip-info").css('pointer-events','none');
jQuery("#product_unstitched").css('opacity','1');
jQuery("#product_name").css('opacity','1');
// If you want to do something with the waist and hip values, you can use them as needed
console.log(productTitle); // Output: Ivory Bridal Hand Crafted Lehenga In Vegan Raw Silk
console.log(waist); // Output: Waist - 32in
console.log(hip); // Output: Hip - 42in



   //  if (formType.includes("readyMade")) {
   //    // document.getElementsByClassName('contact_message').value = formType;
   //    jQuery(".core__group--items .core__group--item:first-child").addClass('activeForm');
   //  } else if (formType.includes("unstitched")) {
   //    // document.getElementsByClassName('contact_message').value = formType;
   //    jQuery(".core__group--items .core__group--item:nth-child(2)").addClass('activeForm');
   //  }

  

});